import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import type { FetchFamilyMembersSuccessResponse } from '../../types/api/response/familyMember'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import { filterNonNullQueryParams } from '@/modules/Core/utils'

export const QUERY_KEY = 'update-profile/family-members'
const ENDPOINT = '/tripmentor/Family/Members'

export function fetchFamilyMembers({
  query,
  page,
  size,
}: {
  query: string
  page: number
  size: number
}) {
  const params = filterNonNullQueryParams({ query, page, size })

  return axiosInstance
    .get<FetchFamilyMembersSuccessResponse>(ENDPOINT, {
      params,
    })
    .then((response) => response.data)
}

export function useFamilyMembersQuery(
  {
    query,
    page,
    size,
  }: {
    query: Ref<string>
    page: Ref<number>
    size: Ref<number>
  },
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchFamilyMembers>>>
) {
  return useQuery({
    queryKey: [QUERY_KEY, query, page, size],
    queryFn: () =>
      fetchFamilyMembers({
        query: query.value,
        page: page.value,
        size: size.value,
      }),
    ...options,
    keepPreviousData: true,
  })
}
